import React, { useState } from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import CarFilter from '../components/cars/CarFilter';
import CarList from '../components/cars/CarList';
import banner from '../assets/banner1.png';
import Hero from '../components/home/Hero';
import './Home.css';

const HomePage = () => {
  const [filters, setFilters] = useState({});

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    console.log('Filtre actualizate:', newFilters);
  };

  const handleSearch = (searchFilters) => {
    console.log('Caută cu filtrele:', searchFilters);
    // Curăță filtrele goale
    const cleanFilters = Object.entries(searchFilters).reduce((acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});
    
    setFilters(cleanFilters);
  };

  return (
    <>
      <div className="home-container">
        <div className="home-hero">
          <Hero />
          {/* <img src={banner} alt="DLC Autocenter Banner" className="home-banner" /> */}
          <div style={{marginBottom:'20px'}} className="hero-overlay">
            {/* <h1 style={{color:'black'}}>Găsește mașina perfectă</h1>
            <p>Cele mai bune oferte pentru mașini second-hand de calitate</p> */}
          </div>
        </div> 

        {/* Secțiunea de filtrare */}
        <div style={{marginTop:'10px'}} className="filter-section">
          <CarFilter
            onFilterChange={handleFilterChange}
            onSearch={handleSearch}
          />
        </div>

        {/* Secțiunea cu mașinile */}
        <div className="cars-section">
          <div style={{marginBottom:'20px'}} className="section-header">
            <h2>Parcul nostru auto</h2>
            <p>Descoperă cele mai bune oferte</p>
          </div>
          <CarList filters={filters} />
        </div>

        
      </div>
    </>
  );
};

export default HomePage;